import {
  addUrlOptionsStr,
  formatDate, formatDateByDate,
  verifyDateInterval, deadTime, formatMoney,
  getFormatAreaByApi,
  validator,
} from '@smart/util-web';
import { Message } from 'element-ui';
import Config from '@smart/config';
import { UPLOAD_DOMAIN, APPID, getBaseUrl } from '@/config';
import router from '../router'

// 外部图片
const imgPrefix = (path, defaultPath, options) => {
  if (!path && !defaultPath) {
    return require('@/static/img/default_goods.png');
  }
  if (!path && defaultPath) {
    if (defaultPath.startsWith('data:')) {
      return defaultPath;
    }
    path = defaultPath; // eslint-disable-line
  }
  if (path.startsWith('/img')) {
    return path;
  }
  if (path.startsWith('http://') || path.startsWith('https://')) {
    // 如果图片是完整的图片， 或是项目中的静态图片，则直接返回路径
    return addUrlOptionsStr(path, options);
  }
  return addUrlOptionsStr(`${UPLOAD_DOMAIN}${path}`, options);
};
export const toLogin = fullPath => {
  router.push('/login' + (fullPath?`?source=${encodeURIComponent(fullPath)}`:''))
};
// calcNum('add/subtract', 0.1, 0.2, 2);
export const calcNum = (operation, num1, num2, precision = 2) => {
  const adjustPrecision = (num) => {
    const [integerPart, decimalPart] = num.toString().split('.');
    return decimalPart ? decimalPart.length : 0;
  };
  const factor = Math.pow(10, Math.max(adjustPrecision(num1), adjustPrecision(num2)));
  let result;

  switch (operation) {
    case 'add':
      result = (num1 * factor + num2 * factor) / factor;
      break;
    case 'subtract':
      result = (num1 * factor - num2 * factor) / factor;
      break;
    case 'multiply':
      result = (num1 * factor) * (num2 * factor) / (factor * factor);
      break;
    case 'divide':
      result = (num1 * factor) / (num2 * factor);
      break;
    default:
      throw new Error('Unsupported operation');
  }
  const finalFactor = Math.pow(10, precision);
  result = Math.round(result * finalFactor) / finalFactor;

  return result;
};

export const downloadFile = async (url, filename = 'image.jpg') => {
  try {
    const response = await fetch(url)
    const blob = await response.blob()
    const objectUrl = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = objectUrl
    a.download = filename
    a.click()
    URL.revokeObjectURL(objectUrl)
  } catch (error) {
    Promise.reject(error)
    console.error('下载失败:', error)
  }
}

export const copyText = (text, showMsg = true) => {
  return new Promise((resolve, reject) => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text)
        .then(() => {
          resolve('复制成功');
          if (showMsg) Message.success('复制成功');
        })
        .catch((err) => reject('复制失败无法复制文本到剪贴板: ' + err));
    } else {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'absolute';
      textArea.style.opacity = 0;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        const successful = document.execCommand('copy');
        if (successful) {
          resolve('复制成功');
          if (showMsg) Message.success('复制成功');
        } else {
          reject('复制失败无法复制文本到剪贴板');
        }
      } catch (err) {
        reject('复制失败无法复制文本到剪贴板: ' + err);
      }
      document.body.removeChild(textArea);
    }
  });
};
export default {
  install(Vue) {
    Vue.prototype.$Config = Config;
    
    Vue.prototype.$toLogin = toLogin;
    // 格式化日期
    Vue.prototype.$formatDate = formatDate;
    Vue.prototype.$formatDateByDate = formatDateByDate;
    Vue.filter('formatDate', formatDate);
    // 处理查询日期间隔
    Vue.prototype.$verifyDateInterval = verifyDateInterval;
    // 到期时间
    Vue.prototype.$deadTime = deadTime;
    Vue.filter('deadTime', deadTime);
    // 图片
    Vue.filter('imgPrefix', imgPrefix);
    Vue.prototype.$imgPrefix = imgPrefix;
    // 格式化金额
    Vue.prototype.$formatMoney = formatMoney;
    Vue.filter('formatMoney', formatMoney);
    // 加减法计算
    Vue.prototype.$calcNum = calcNum
    // 复制文本
    Vue.prototype.$copyText = copyText
    // 下载文件
    Vue.prototype.$downloadFile = downloadFile
    // 获取基本路径
    Vue.prototype.$getBaseUrl = getBaseUrl;
    Vue.prototype.$getUploadUrl = `${getBaseUrl()}/hengxin/erp/api/platform/biz/upload`;
    // 获取APPID
    Vue.prototype.$getAppId = APPID;

    Vue.prototype.$validator = (value, args1, args2) => validator(value, args1, args2).catch((err) => {
      Message.error(err);
      return Promise.reject(err);
    });
  },
};



export const getQrcodeSrc = (content, size = 200) => `https://api.91joylife.net/saas/cloud/user/qrcode/create?size=${size}&content=${encodeURIComponent(content)}`;
